"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isModelClass = isModelClass;
exports.isCollection = isCollection;
function isModelClass(o) {
    return !!o.Attribute;
}

function isCollection(o) {
    return !!o.models;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/nestedUtils.js
// module id = 735
// module chunks = 118